var AppContainer = /** @class */ (function () {
    function AppContainer() {
    }
    AppContainer.prototype.init = function (app) {
        if (this._app) {
            return; // TODO: Add warning?
        }
        this._app = app;
        this._app.init();
        this._app.setup();
    };
    Object.defineProperty(AppContainer.prototype, "app", {
        get: function () {
            if (!this._app)
                throw 'App not set!';
            return this._app;
        },
        enumerable: false,
        configurable: true
    });
    return AppContainer;
}());
export { AppContainer };
export var appContainer = new AppContainer();
export function app() {
    return appContainer.app;
}
export default AppContainer;
